export default "__VITE_ASSET__ghj2HtTp__"